
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexlspUbkqhafF2QFNapOu56OUDqdKOdGgNJlllvfrgjMUMeta } from "/codebuild/output/src244454212/src/storefront/pages/index.vue?macro=true";
import { default as loginyi6Ucz11A9gfsMBG7jw4TrF1Z_em4EbDPFwks0S7hUwMeta } from "/codebuild/output/src244454212/src/storefront/pages/login.vue?macro=true";
import { default as cookierrMb2f4tNY1CzMjHEwCRVETU07tuS4_45JzdWEgRyP9GUMeta } from "/codebuild/output/src244454212/src/storefront/pages/cookie.vue?macro=true";
import { default as searchsMEDIG1dOfYd0xMBzO63VB8sE2mY3sQZfZZbTrosjL4Meta } from "/codebuild/output/src244454212/src/storefront/pages/search.vue?macro=true";
import { default as my_45cartyxaCWOLqUH3n4hHiqVRx3UM81mzHtlYnnHAuZsXJPwUMeta } from "/codebuild/output/src244454212/src/storefront/pages/my-cart.vue?macro=true";
import { default as on_45saleE2YjRYm4V6pBMavTi680LGBW4QjGiKUe_srwDmh5DtkMeta } from "/codebuild/output/src244454212/src/storefront/pages/on-sale.vue?macro=true";
import { default as about_45usmwlsaKBf0khhBp4PJD7wbTfQPwAvioa0S7ds06roBxYMeta } from "/codebuild/output/src244454212/src/storefront/pages/about-us.vue?macro=true";
import { default as book_45clublID3zJhmUKPEOpUVmI1sDLVlTV_45WYJsQR_fR4Uk2KgEMeta } from "/codebuild/output/src244454212/src/storefront/pages/book-club.vue?macro=true";
import { default as contact_45usybBVRiGLzq8caxStTyNEkyoWglFeuzjJ76Di8KOiAToMeta } from "/codebuild/output/src244454212/src/storefront/pages/contact-us.vue?macro=true";
import { default as newspapersv7SP6Nfm_45QQmxg5hrEPHl5VUK2GNH9Q2tjvaFEbFPhIMeta } from "/codebuild/output/src244454212/src/storefront/pages/newspapers.vue?macro=true";
import { default as _91slug_93mkg123Tn3BZzvsS6VU8RGM1dVYY4_45NhAHRM0hbXoEmIMeta } from "/codebuild/output/src244454212/src/storefront/pages/book/[slug].vue?macro=true";
import { default as indexKWnVdNYlk_EWKns2Wz4UT1dSuq3CO2i8aOJSZlD9dwIMeta } from "/codebuild/output/src244454212/src/storefront/pages/books/index.vue?macro=true";
import { default as barion_45startsrsoliVwutEyIvFQbvhmFp5pE4XpcJv7oHgfv_45BpvsoMeta } from "/codebuild/output/src244454212/src/storefront/pages/barion-start.vue?macro=true";
import { default as paypal_45startK_Nhbg9sWQ0_45OtXMM_455bM2tZ3HaWjMvU3QwUtBVChMoMeta } from "/codebuild/output/src244454212/src/storefront/pages/paypal-start.vue?macro=true";
import { default as _91_46_46_46catchAll_93ilIJfdIadlnUqvo0lJHBg_455d9VEJ4NjEun8yeDDJQlMMeta } from "/codebuild/output/src244454212/src/storefront/pages/[...catchAll].vue?macro=true";
import { default as indexzfmEnH17x768CEGZP_4c8MjhQV7YgLqTXvmG_OwrEPQMeta } from "/codebuild/output/src244454212/src/storefront/pages/checkout/index.vue?macro=true";
import { default as payment_45resultETVLeMScNdxYG2UFSOLlzT0s7yv3O7on0U1RGfTsxYEMeta } from "/codebuild/output/src244454212/src/storefront/pages/payment-result.vue?macro=true";
import { default as privacy_45policyPtnZPiOj1r_453t9aDK0El1OhjiKpdmPqja8UYKmq9mQ8Meta } from "/codebuild/output/src244454212/src/storefront/pages/privacy-policy.vue?macro=true";
import { default as indexjtP6kMve4iy30iAixCdnCOTCovOU8CPCP65IsJb54fUMeta } from "/codebuild/output/src244454212/src/storefront/pages/my-orders/index.vue?macro=true";
import { default as newly_45publishedGMdD0JT5ZOH2z_45D5VenDYOvBAwBNDyk4GJvVMV67wbAMeta } from "/codebuild/output/src244454212/src/storefront/pages/newly-published.vue?macro=true";
import { default as _91slug_93w_45Rf_45C0y_45gMfGzW6eAkM5eHUAd9GDQ0krgr_45BTW39xIMeta } from "/codebuild/output/src244454212/src/storefront/pages/my-orders/[slug].vue?macro=true";
import { default as thankyouT46tPnI5yJzYEPUjqucqjkYO4MYgRTrGbTqwbJGcOjoMeta } from "/codebuild/output/src244454212/src/storefront/pages/checkout/thankyou.vue?macro=true";
import { default as upcoming_45releasesyZNrakWJm4nmtnwAECeLA7m1wy6fWhnDxivgLU_idnUMeta } from "/codebuild/output/src244454212/src/storefront/pages/upcoming-releases.vue?macro=true";
import { default as terms_45and_45conditionsp74I8qB7SFyfG5_k5n9OilOcWBYVGx1Jh3YnxWqlSVoMeta } from "/codebuild/output/src244454212/src/storefront/pages/terms-and-conditions.vue?macro=true";
import { default as _91slug_93Tf02Vx4NGTPiK4cSCSRsEA5smaiXHZupArgOA7Mbb88Meta } from "/codebuild/output/src244454212/src/storefront/pages/other-language/[slug].vue?macro=true";
import { default as indexRjfXvX5dh6f9i3ztIRTa_45AEHXfKHxmYqM3kqOAh7HvcMeta } from "/codebuild/output/src244454212/src/storefront/pages/other-languages/index.vue?macro=true";
import { default as staff_45recommendationseCYXu6HtF_3pwG73bI2IJcrILMPq24PyLYeGLn7USQcMeta } from "/codebuild/output/src244454212/src/storefront/pages/staff-recommendations.vue?macro=true";
import { default as _91slug_93H2zHKgzK3nKwweOC25DydImNRxU3WtQXkLoRoOfPt_45QMeta } from "/codebuild/output/src244454212/src/storefront/pages/books-by-author/[slug].vue?macro=true";
import { default as indexJOQ8ALSdXv4gAUNIkcCYwzDYx9D8UuXf1lFUx7VQrYkMeta } from "/codebuild/output/src244454212/src/storefront/pages/books/[category]/index.vue?macro=true";
import { default as _91slug_93d_J_0Zoje5voTAkaYQhYCjPxAL03hj8RTVn4CCrxSwIMeta } from "/codebuild/output/src244454212/src/storefront/pages/menu-navigation/[slug].vue?macro=true";
import { default as bestsellers_45of_45the_45monthdUlzWbFcj4PgyjKbidCYLVs7zTved5F7QLSjnpup6iQMeta } from "/codebuild/output/src244454212/src/storefront/pages/bestsellers-of-the-month.vue?macro=true";
import { default as _91slug_93iLnAMgwYcxBwxdbVKfhg_Dnf_uU1xc0tJIG_45pVvO4mIMeta } from "/codebuild/output/src244454212/src/storefront/pages/stationary-and-gift/[slug].vue?macro=true";
import { default as indexz1KCLVyxUrQe0tKGu1mQ4imwky2ovFh706DU8xkUh_458Meta } from "/codebuild/output/src244454212/src/storefront/pages/stationary-and-gifts/index.vue?macro=true";
import { default as index8wE2uTscX5ryxmgWe41lZdDN0Oz1nBsnX8vSA_P1MM0Meta } from "/codebuild/output/src244454212/src/storefront/pages/other-languages/[category]/index.vue?macro=true";
import { default as purchase_45and_45shipping_45conditions_IW2vgRlRHrH38NcwIRuHtYGc27eouy7xvxkw6J54J4Meta } from "/codebuild/output/src244454212/src/storefront/pages/purchase-and-shipping-conditions.vue?macro=true";
import { default as indexzzGAXYFqZVRzywG6FpfaWk2S9IIdFOZIPV8TSRNfDegMeta } from "/codebuild/output/src244454212/src/storefront/pages/books/[category]/[subcategory]/index.vue?macro=true";
import { default as _91_91subcategory_93_93SXYrzAIVOPkjyCZUM_45MAV9DyhbeJVHDwFsI9G3k2eu4Meta } from "/codebuild/output/src244454212/src/storefront/pages/products/[[category]]/[[subcategory]].vue?macro=true";
import { default as indexgHlkm2AS1WA_45FunscKPgcs2uLaSR2y7Pd6xAGBHJN3QMeta } from "/codebuild/output/src244454212/src/storefront/pages/stationary-and-gifts/[category]/index.vue?macro=true";
import { default as indexLkFGfZdq3QKKAQkIgHw67kssBXGwkMoe5xLx0o9iXscMeta } from "/codebuild/output/src244454212/src/storefront/pages/other-languages/[category]/[subcategory]/index.vue?macro=true";
import { default as index7DiImMYqKxCKhYeXBZaRrok29ensT9pg3Uiq_45VxChMEMeta } from "/codebuild/output/src244454212/src/storefront/pages/stationary-and-gifts/[category]/[subcategory]/index.vue?macro=true";
export default [
  {
    name: "index___hu",
    path: "/hu",
    meta: indexlspUbkqhafF2QFNapOu56OUDqdKOdGgNJlllvfrgjMUMeta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/",
    meta: indexlspUbkqhafF2QFNapOu56OUDqdKOdGgNJlllvfrgjMUMeta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/index.vue")
  },
  {
    name: "login___hu",
    path: "/hu/bejelentkezes",
    meta: {"middleware":"auth"},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/login.vue")
  },
  {
    name: "login___en",
    path: "/login",
    meta: {"middleware":"auth"},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/login.vue")
  },
  {
    name: "cookie___hu",
    path: "/hu/suti",
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/cookie.vue")
  },
  {
    name: "cookie___en",
    path: "/cookie",
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/cookie.vue")
  },
  {
    name: "search___hu",
    path: "/hu/kereses",
    meta: searchsMEDIG1dOfYd0xMBzO63VB8sE2mY3sQZfZZbTrosjL4Meta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/search.vue")
  },
  {
    name: "search___en",
    path: "/search",
    meta: searchsMEDIG1dOfYd0xMBzO63VB8sE2mY3sQZfZZbTrosjL4Meta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/search.vue")
  },
  {
    name: "my-cart___hu",
    path: "/hu/kosaram",
    meta: my_45cartyxaCWOLqUH3n4hHiqVRx3UM81mzHtlYnnHAuZsXJPwUMeta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/my-cart.vue")
  },
  {
    name: "my-cart___en",
    path: "/my-cart",
    meta: my_45cartyxaCWOLqUH3n4hHiqVRx3UM81mzHtlYnnHAuZsXJPwUMeta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/my-cart.vue")
  },
  {
    name: "on-sale___hu",
    path: "/hu/akciok",
    meta: on_45saleE2YjRYm4V6pBMavTi680LGBW4QjGiKUe_srwDmh5DtkMeta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/on-sale.vue")
  },
  {
    name: "on-sale___en",
    path: "/on-sale",
    meta: on_45saleE2YjRYm4V6pBMavTi680LGBW4QjGiKUe_srwDmh5DtkMeta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/on-sale.vue")
  },
  {
    name: "about-us___hu",
    path: "/hu/rolunk",
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/about-us.vue")
  },
  {
    name: "about-us___en",
    path: "/about-us",
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/about-us.vue")
  },
  {
    name: "book-club___hu",
    path: "/hu/konyvklub",
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/book-club.vue")
  },
  {
    name: "book-club___en",
    path: "/book-club",
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/book-club.vue")
  },
  {
    name: "contact-us___hu",
    path: "/hu/kapcsolat",
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/contact-us.vue")
  },
  {
    name: "contact-us___en",
    path: "/contact-us",
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/contact-us.vue")
  },
  {
    name: "newspapers___hu",
    path: "/hu/ujsagok-es-magazinok",
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/newspapers.vue")
  },
  {
    name: "newspapers___en",
    path: "/newspapers-and-magazines",
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/newspapers.vue")
  },
  {
    name: "book-slug___hu",
    path: "/hu/konyv/:slug()",
    meta: _91slug_93mkg123Tn3BZzvsS6VU8RGM1dVYY4_45NhAHRM0hbXoEmIMeta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/book/[slug].vue")
  },
  {
    name: "book-slug___en",
    path: "/book/:slug()",
    meta: _91slug_93mkg123Tn3BZzvsS6VU8RGM1dVYY4_45NhAHRM0hbXoEmIMeta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/book/[slug].vue")
  },
  {
    name: "books___hu",
    path: "/hu/konyvek",
    meta: indexKWnVdNYlk_EWKns2Wz4UT1dSuq3CO2i8aOJSZlD9dwIMeta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/books/index.vue")
  },
  {
    name: "books___en",
    path: "/books",
    meta: indexKWnVdNYlk_EWKns2Wz4UT1dSuq3CO2i8aOJSZlD9dwIMeta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/books/index.vue")
  },
  {
    name: "barion-start___hu",
    path: "/hu/barion-fizetes",
    meta: { ...(barion_45startsrsoliVwutEyIvFQbvhmFp5pE4XpcJv7oHgfv_45BpvsoMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/barion-start.vue")
  },
  {
    name: "barion-start___en",
    path: "/barion-start",
    meta: { ...(barion_45startsrsoliVwutEyIvFQbvhmFp5pE4XpcJv7oHgfv_45BpvsoMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/barion-start.vue")
  },
  {
    name: "paypal-start___hu",
    path: "/hu/paypal-fizetes",
    meta: { ...(paypal_45startK_Nhbg9sWQ0_45OtXMM_455bM2tZ3HaWjMvU3QwUtBVChMoMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/paypal-start.vue")
  },
  {
    name: "paypal-start___en",
    path: "/paypal-start",
    meta: { ...(paypal_45startK_Nhbg9sWQ0_45OtXMM_455bM2tZ3HaWjMvU3QwUtBVChMoMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/paypal-start.vue")
  },
  {
    name: "catchAll___hu",
    path: "/hu/:catchAll(.*)*",
    meta: _91_46_46_46catchAll_93ilIJfdIadlnUqvo0lJHBg_455d9VEJ4NjEun8yeDDJQlMMeta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/[...catchAll].vue")
  },
  {
    name: "catchAll___en",
    path: "/:catchAll(.*)*",
    meta: _91_46_46_46catchAll_93ilIJfdIadlnUqvo0lJHBg_455d9VEJ4NjEun8yeDDJQlMMeta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/[...catchAll].vue")
  },
  {
    name: "checkout___hu",
    path: "/hu/megrendeles",
    meta: { ...(indexzfmEnH17x768CEGZP_4c8MjhQV7YgLqTXvmG_OwrEPQMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/checkout/index.vue")
  },
  {
    name: "checkout___en",
    path: "/checkout",
    meta: { ...(indexzfmEnH17x768CEGZP_4c8MjhQV7YgLqTXvmG_OwrEPQMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/checkout/index.vue")
  },
  {
    name: "payment-result___hu",
    path: "/hu/barion-eredmeny",
    meta: { ...(payment_45resultETVLeMScNdxYG2UFSOLlzT0s7yv3O7on0U1RGfTsxYEMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/payment-result.vue")
  },
  {
    name: "payment-result___en",
    path: "/barion-result",
    meta: { ...(payment_45resultETVLeMScNdxYG2UFSOLlzT0s7yv3O7on0U1RGfTsxYEMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/payment-result.vue")
  },
  {
    name: "privacy-policy___hu",
    path: "/hu/adatkezelesi-tajekoztato",
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___en",
    path: "/privacy-policy",
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/privacy-policy.vue")
  },
  {
    name: "my-orders___hu",
    path: "/hu/rendeleseim",
    meta: {"middleware":["auth"]},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/my-orders/index.vue")
  },
  {
    name: "my-orders___en",
    path: "/my-orders",
    meta: {"middleware":["auth"]},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/my-orders/index.vue")
  },
  {
    name: "newly-published___hu",
    path: "/hu/ujdonsagok",
    meta: newly_45publishedGMdD0JT5ZOH2z_45D5VenDYOvBAwBNDyk4GJvVMV67wbAMeta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/newly-published.vue")
  },
  {
    name: "newly-published___en",
    path: "/newly-published",
    meta: newly_45publishedGMdD0JT5ZOH2z_45D5VenDYOvBAwBNDyk4GJvVMV67wbAMeta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/newly-published.vue")
  },
  {
    name: "my-orders-slug___hu",
    path: "/hu/rendeleseim/:slug()",
    meta: {"middleware":["auth"]},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/my-orders/[slug].vue")
  },
  {
    name: "my-orders-slug___en",
    path: "/my-orders/:slug()",
    meta: {"middleware":["auth"]},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/my-orders/[slug].vue")
  },
  {
    name: "checkout-thankyou___hu",
    path: "/hu/megrendeles-koszonjuk",
    meta: thankyouT46tPnI5yJzYEPUjqucqjkYO4MYgRTrGbTqwbJGcOjoMeta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/checkout/thankyou.vue")
  },
  {
    name: "checkout-thankyou___en",
    path: "/checkout-thankyou",
    meta: thankyouT46tPnI5yJzYEPUjqucqjkYO4MYgRTrGbTqwbJGcOjoMeta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/checkout/thankyou.vue")
  },
  {
    name: "upcoming-releases___hu",
    path: "/hu/varhato-megjelenesek",
    meta: upcoming_45releasesyZNrakWJm4nmtnwAECeLA7m1wy6fWhnDxivgLU_idnUMeta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/upcoming-releases.vue")
  },
  {
    name: "upcoming-releases___en",
    path: "/upcoming-releases",
    meta: upcoming_45releasesyZNrakWJm4nmtnwAECeLA7m1wy6fWhnDxivgLU_idnUMeta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/upcoming-releases.vue")
  },
  {
    name: "terms-and-conditions___hu",
    path: "/hu/altalanos-szerzodesi-feltetelek",
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/terms-and-conditions.vue")
  },
  {
    name: "terms-and-conditions___en",
    path: "/terms-and-conditions",
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/terms-and-conditions.vue")
  },
  {
    name: "other-language-slug___hu",
    path: "/hu/egyeb-idegen-nyelvu-konyv/:slug()",
    meta: _91slug_93Tf02Vx4NGTPiK4cSCSRsEA5smaiXHZupArgOA7Mbb88Meta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/other-language/[slug].vue")
  },
  {
    name: "other-language-slug___en",
    path: "/other-language/:slug()",
    meta: _91slug_93Tf02Vx4NGTPiK4cSCSRsEA5smaiXHZupArgOA7Mbb88Meta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/other-language/[slug].vue")
  },
  {
    name: "other-languages___hu",
    path: "/hu/egyeb-idegen-nyelvu-konyvek",
    meta: indexRjfXvX5dh6f9i3ztIRTa_45AEHXfKHxmYqM3kqOAh7HvcMeta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/other-languages/index.vue")
  },
  {
    name: "other-languages___en",
    path: "/other-languages",
    meta: indexRjfXvX5dh6f9i3ztIRTa_45AEHXfKHxmYqM3kqOAh7HvcMeta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/other-languages/index.vue")
  },
  {
    name: "staff-recommendations___hu",
    path: "/hu/mi-ajanljuk",
    meta: staff_45recommendationseCYXu6HtF_3pwG73bI2IJcrILMPq24PyLYeGLn7USQcMeta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/staff-recommendations.vue")
  },
  {
    name: "staff-recommendations___en",
    path: "/staff-recommendations",
    meta: staff_45recommendationseCYXu6HtF_3pwG73bI2IJcrILMPq24PyLYeGLn7USQcMeta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/staff-recommendations.vue")
  },
  {
    name: "books-by-author-slug___hu",
    path: "/hu/szerzo-muvei/:slug()",
    meta: _91slug_93H2zHKgzK3nKwweOC25DydImNRxU3WtQXkLoRoOfPt_45QMeta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/books-by-author/[slug].vue")
  },
  {
    name: "books-by-author-slug___en",
    path: "/books-by-author/:slug()",
    meta: _91slug_93H2zHKgzK3nKwweOC25DydImNRxU3WtQXkLoRoOfPt_45QMeta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/books-by-author/[slug].vue")
  },
  {
    name: "books-category___hu",
    path: "/hu/konyvek/:category()",
    meta: indexJOQ8ALSdXv4gAUNIkcCYwzDYx9D8UuXf1lFUx7VQrYkMeta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/books/[category]/index.vue")
  },
  {
    name: "books-category___en",
    path: "/books/:category()",
    meta: indexJOQ8ALSdXv4gAUNIkcCYwzDYx9D8UuXf1lFUx7VQrYkMeta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/books/[category]/index.vue")
  },
  {
    name: "menu-navigation-slug___hu",
    path: "/hu/menu-navigacio/:slug()",
    meta: _91slug_93d_J_0Zoje5voTAkaYQhYCjPxAL03hj8RTVn4CCrxSwIMeta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/menu-navigation/[slug].vue")
  },
  {
    name: "menu-navigation-slug___en",
    path: "/menu-navigation/:slug()",
    meta: _91slug_93d_J_0Zoje5voTAkaYQhYCjPxAL03hj8RTVn4CCrxSwIMeta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/menu-navigation/[slug].vue")
  },
  {
    name: "bestsellers-of-the-month___hu",
    path: "/hu/a-honap-sikerkonyvei",
    meta: bestsellers_45of_45the_45monthdUlzWbFcj4PgyjKbidCYLVs7zTved5F7QLSjnpup6iQMeta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/bestsellers-of-the-month.vue")
  },
  {
    name: "bestsellers-of-the-month___en",
    path: "/bestsellers-of-the-month",
    meta: bestsellers_45of_45the_45monthdUlzWbFcj4PgyjKbidCYLVs7zTved5F7QLSjnpup6iQMeta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/bestsellers-of-the-month.vue")
  },
  {
    name: "stationary-and-gift-slug___hu",
    path: "/hu/notesz-es-ajandektargy/:slug()",
    meta: _91slug_93iLnAMgwYcxBwxdbVKfhg_Dnf_uU1xc0tJIG_45pVvO4mIMeta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/stationary-and-gift/[slug].vue")
  },
  {
    name: "stationary-and-gift-slug___en",
    path: "/stationary-and-gift/:slug()",
    meta: _91slug_93iLnAMgwYcxBwxdbVKfhg_Dnf_uU1xc0tJIG_45pVvO4mIMeta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/stationary-and-gift/[slug].vue")
  },
  {
    name: "stationary-and-gifts___hu",
    path: "/hu/noteszek-es-ajandektargyak",
    meta: indexz1KCLVyxUrQe0tKGu1mQ4imwky2ovFh706DU8xkUh_458Meta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/stationary-and-gifts/index.vue")
  },
  {
    name: "stationary-and-gifts___en",
    path: "/stationary-and-gifts",
    meta: indexz1KCLVyxUrQe0tKGu1mQ4imwky2ovFh706DU8xkUh_458Meta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/stationary-and-gifts/index.vue")
  },
  {
    name: "other-languages-category___hu",
    path: "/hu/egyeb-idegen-nyelvu-konyvek/:category()",
    meta: index8wE2uTscX5ryxmgWe41lZdDN0Oz1nBsnX8vSA_P1MM0Meta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/other-languages/[category]/index.vue")
  },
  {
    name: "other-languages-category___en",
    path: "/other-languages/:category()",
    meta: index8wE2uTscX5ryxmgWe41lZdDN0Oz1nBsnX8vSA_P1MM0Meta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/other-languages/[category]/index.vue")
  },
  {
    name: "purchase-and-shipping-conditions___hu",
    path: "/hu/vasarlasi-es-szallitasi-feltetelek",
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/purchase-and-shipping-conditions.vue")
  },
  {
    name: "purchase-and-shipping-conditions___en",
    path: "/purchase-and-shipping-conditions",
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/purchase-and-shipping-conditions.vue")
  },
  {
    name: "books-category-subcategory___hu",
    path: "/hu/konyvek/:category()/:subcategory()",
    meta: indexzzGAXYFqZVRzywG6FpfaWk2S9IIdFOZIPV8TSRNfDegMeta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/books/[category]/[subcategory]/index.vue")
  },
  {
    name: "books-category-subcategory___en",
    path: "/books/:category()/:subcategory()",
    meta: indexzzGAXYFqZVRzywG6FpfaWk2S9IIdFOZIPV8TSRNfDegMeta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/books/[category]/[subcategory]/index.vue")
  },
  {
    name: "products-category-subcategory___hu",
    path: "/hu/product/:category?/:subcategory?",
    meta: _91_91subcategory_93_93SXYrzAIVOPkjyCZUM_45MAV9DyhbeJVHDwFsI9G3k2eu4Meta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/products/[[category]]/[[subcategory]].vue")
  },
  {
    name: "products-category-subcategory___en",
    path: "/products/:category?/:subcategory?",
    meta: _91_91subcategory_93_93SXYrzAIVOPkjyCZUM_45MAV9DyhbeJVHDwFsI9G3k2eu4Meta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/products/[[category]]/[[subcategory]].vue")
  },
  {
    name: "stationary-and-gifts-category___hu",
    path: "/hu/noteszek-es-ajandektargyak/:category()",
    meta: indexgHlkm2AS1WA_45FunscKPgcs2uLaSR2y7Pd6xAGBHJN3QMeta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/stationary-and-gifts/[category]/index.vue")
  },
  {
    name: "stationary-and-gifts-category___en",
    path: "/stationary-and-gifts/:category()",
    meta: indexgHlkm2AS1WA_45FunscKPgcs2uLaSR2y7Pd6xAGBHJN3QMeta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/stationary-and-gifts/[category]/index.vue")
  },
  {
    name: "other-languages-category-subcategory___hu",
    path: "/hu/egyeb-idegen-nyelvu-konyvek/:categorysubcategory?",
    meta: indexLkFGfZdq3QKKAQkIgHw67kssBXGwkMoe5xLx0o9iXscMeta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/other-languages/[category]/[subcategory]/index.vue")
  },
  {
    name: "other-languages-category-subcategory___en",
    path: "/other-languages/:category()/:subcategory()",
    meta: indexLkFGfZdq3QKKAQkIgHw67kssBXGwkMoe5xLx0o9iXscMeta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/other-languages/[category]/[subcategory]/index.vue")
  },
  {
    name: "stationary-and-gifts-category-subcategory___hu",
    path: "/hu/noteszek-es-ajandektargyak/:categorysubcategory?",
    meta: index7DiImMYqKxCKhYeXBZaRrok29ensT9pg3Uiq_45VxChMEMeta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/stationary-and-gifts/[category]/[subcategory]/index.vue")
  },
  {
    name: "stationary-and-gifts-category-subcategory___en",
    path: "/stationary-and-gifts/:category()/:subcategory()",
    meta: index7DiImMYqKxCKhYeXBZaRrok29ensT9pg3Uiq_45VxChMEMeta || {},
    component: () => import("/codebuild/output/src244454212/src/storefront/pages/stationary-and-gifts/[category]/[subcategory]/index.vue")
  }
]